module.exports = __webpack_public_path__ + "img/callme2.4a41fabf.jpg";